import { required, requiredIf } from 'vuelidate/lib/validators'
import { omit } from 'lodash'

import { DateTimeHelper, ValidatorsHelper } from '@/helpers'
import { dateOfBirth, firstName } from '@/validations/components'

export default {
  form: {
    address: {
      required,
      location: ValidatorsHelper.isLocation,
    },
    contractNumber: {
      required: requiredIf(function () {
        return this.isCollectiveContract
      }),
      contractNumber: function (value) {
        return ValidatorsHelper.isContractNumber(value)
      },
    },
    contractStartDate: {
      date: ValidatorsHelper.isDate,
      dateRange: ValidatorsHelper.isInDateRange(
        DateTimeHelper.getMinContractStartDate(),
        DateTimeHelper.getMaxContractStartDate()
      ),
    },
    dateOfEntry: {
      required: requiredIf(function (value) {
        return value.immigrant
      }),
      date: ValidatorsHelper.isDate,
      dateRange: ValidatorsHelper.isInDateRange(
        DateTimeHelper.getMinContractStartDate(),
        DateTimeHelper.getMaxContractStartDate()
      ),
    },
    immigrant: {
      required: required,
    },
    persons: {
      required,
      $each: {
        collectivePersonGroup: {
          required: requiredIf(function () {
            return this.personGroups?.length > 0
          }),
        },
        personData: {
          dateOfBirth,
          firstName: {
            //TODO omit will be removed from lodash v5, find another solution
            ...omit(firstName, ['required']),
          },
          gender: {
            required,
          },
        },
      },
    },
    salesPartnerEmail: {
      email: ValidatorsHelper.isMail,
    },
  },
}
